import { ValidationError } from '@/types/validation';
import { isEmptyValue } from '@/util/typeGuards';
import { TextField, TextFieldProps } from '@mui/material';
import { FC, useEffect, useState } from 'react';
import { useDebounce } from './Debouncer';

export type ParamTextFieldProps = TextFieldProps & {
  disableFields?: boolean;
  errors?: ValidationError[];
};

const TextFieldWrapper: FC<ParamTextFieldProps> = (props) => {
  const [value, setValue] = useState(props.value);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.stopPropagation();
    setValue(e.target.value);
  };

  useDebounce(() => {
    props.onChange && props.onChange({ currentTarget: { value } } as React.ChangeEvent<HTMLInputElement>);
  }, [value]);

  useEffect(() => {
    setValue(!props.value || isEmptyValue(props.value) ? '' : props.value);
  }, [props.value]);

  return (
    <TextField
      {...props}
      error={Boolean(props.errors?.length || (props.required && props.value === ''))}
      InputLabelProps={{ shrink: Boolean(value || isEmptyValue(props.value)) }}
      value={value}
      onChange={handleChange}
      InputProps={{ ...props.InputProps, autoComplete: 'off' }}
    />
  );
};

export default TextFieldWrapper;
